import React, { PureComponent } from 'react'
import Img from 'gatsby-image'
import classnames from 'classnames'
import ReactPlayer from 'react-player'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'

import ErrorBoundary from '../error'

import play from '../../img/icons/play.svg'
import stop from '../../img/icons/stop.svg'
import mute from '../../img/icons/mute.svg'
import audio from '../../img/icons/audio.svg'
import full from '../../img/icons/full.svg'

import poster from '../../img/poster.png'

class InlineVideo extends React.Component {
  state = {
    isIOS: false,
    url: null,
    controls: true,
    playing: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    loop: false,
    height: null,
    ready: false,
  }

  componentWillUnmount() {
    this.player && this.player.getInternalPlayer().remove()
  }

  componentDidMount() {
    this.setState({
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    })

    window.addEventListener('resize', this.updateHeight.bind(this))

    this.player
      .getInternalPlayer()
      .addEventListener('webkitendfullscreen', () => {
        this.setState({ playing: false })
      })

      // this.player.getInternalPlayer().style['object-fit'] = 'cover'
      this.updateHeight()
  }

  updateHeight() {
    this.player && this.setState({ height: this.player.wrapper.offsetHeight })
  }

  onReady = () => {
    const { urls } = this.props
    const { isIOS } = this.state

    this.setState({
      ready: true,
      url: isIOS ? urls[1].src : urls[0].src,
    })
    this.updateHeight()
  }

  togglePlay = () => {
    this.setState({
      playing: !this.state.playing,
    })
  }

  render() {
    const { classes, urls, poster } = this.props
    const { playing, muted, controls, height, isIOS, ready } = this.state

    return (
      <React.Fragment>
        {urls && (
          <ErrorBoundary>
            <div className={classes.inlineVideo}>
              <ReactPlayer
                width="100%"
                height="100%"
                ref={p => (this.player = p)}
                url={isIOS ? urls[1].src : urls[0].src}
                controls={controls}
                playing={playing}
                playsinline
                muted={muted}
                onClick={() => this.togglePlay()}
                onReady={() => this.onReady()}
                config={{
                  file: {
                    attributes: {
                      poster: poster.src,
                    },
                  },
                }}
              />
            </div>
          </ErrorBoundary>
        )}
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(InlineVideo)



// WEBPACK FOOTER //
// ./src/components/video/inline.js